import { Directive, ElementRef, OnInit, Output, EventEmitter } from '@angular/core';

@Directive({
	selector: '[googlePlacesAutocomplete]'
})
export class PlacesAutocompleteDirective implements OnInit {
	@Output() placeSelected: EventEmitter<any> = new EventEmitter();
	private element: HTMLInputElement;

	constructor(elRef: ElementRef) {
		//elRef will get a reference to the element where
		//the directive is placed
		this.element = elRef.nativeElement;
	}

	getFormattedAddress(place) {
		const location_obj = {};
		for (const p in place.address_components) {
			if (p) {
				const item = place.address_components[p];

				location_obj['formatted_address'] = place.formatted_address;
				if (item['types']?.indexOf('locality') > -1) {
					location_obj['locality'] = item['long_name'];
				} else if (item['types']?.indexOf('administrative_area_level_1') > -1) {
					location_obj['admin_area_l1'] = item['short_name'];
				} else if (item['types']?.indexOf('street_number') > -1) {
					location_obj['street_number'] = item['short_name'];
				} else if (item['types']?.indexOf('route') > -1) {
					location_obj['route'] = item['long_name'];
				} else if (item['types']?.indexOf('country') > -1) {
					location_obj['country'] = item['long_name'];
				} else if (item['types']?.indexOf('postal_code') > -1) {
					location_obj['postal_code'] = item['short_name'];
				}
			}
		}

		return location_obj;
	}

	ngOnInit() {}
}
